import registration from './registration.action';
import registrationSlice from '@/state/registration.slice';
import confirmByPhone from './confirm-by-phone.action';
import confirmByEmail from './confirm-by-email.action';
import registrationByInvitation from './registration-by-invitation.action';
import store from '@/state/store';

const resetRegistration = () => {
  store.dispatch(registrationSlice.actions.reset());
}

export { registration, resetRegistration, confirmByPhone, confirmByEmail, registrationByInvitation };
